import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler,HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';



@Injectable() export class AppHttpInterceptor implements HttpInterceptor{

    intercept(req: HttpRequest<any>, next: HttpHandler):Observable<HttpEvent<any>>{
        console.log("INTERCEPTOR REQ :: ")
        console.log(req)
        return next.handle(req).pipe(map(resp=>{
            
            if (resp instanceof HttpResponse) {
                console.log("INTERCEPTOR REPS ::")
                      console.log(resp)
            }
            return resp}))
    }
}